import { useEffect } from "react";
import { PLATFORM_NAME } from "../../features/tenantDefaults";

/**
 * Bezrenderova hlavicka dokumentu podla prevadzky: <title>, favicon,
 * meta description a CSS premenne --tenant-primary (farba tlacidiel)
 * a --tenant-primary-rgb ("214, 20, 10" -- pre priehladne odtiene cez
 * rgba(), nie color-mix(): ten html2canvas pri snimke obrazovky nevie precitat).
 * Bez nej by vsetky prevadzky na rozvozy.sk mali v karte prehliadaca
 * nazov a ikonu z public/index.html.
 */
function nastavLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  if (el.getAttribute("href") !== href) el.setAttribute("href", href);
}

function nastavMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// "#d6140a" -> "214, 20, 10"; cokolvek ine (DB to obmedzuje na #RRGGBB) -> null
export function hexNaRgb(hex) {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  return m ? m.slice(1).map((h) => parseInt(h, 16)).join(", ") : null;
}

function TenantHead({ branding, mode }) {
  useEffect(() => {
    const jePrevadzka = mode === "path" || mode === "host";
    // Na koreni (marketing) title a description vlastni LandingHead. Tento
    // efekt by ich pri kazdom prepocte brandingu prepisal textom pre
    // zakaznikov prevadzky ("Rozvoz obedov ... k vasim dveram").
    if (mode !== "root") {
      document.title = jePrevadzka && branding.displayName !== PLATFORM_NAME
        ? `${branding.displayName} | ${PLATFORM_NAME}`
        : PLATFORM_NAME;
      if (branding.metaDescription) nastavMeta("description", branding.metaDescription);
    }

    if (branding.faviconUrl) nastavLink("icon", branding.faviconUrl);

    const root = document.documentElement;
    if (branding.primaryColor) root.style.setProperty("--tenant-primary", branding.primaryColor);
    else root.style.removeProperty("--tenant-primary");
    const rgb = hexNaRgb(branding.primaryColor);
    if (rgb) root.style.setProperty("--tenant-primary-rgb", rgb);
    else root.style.removeProperty("--tenant-primary-rgb");
  }, [branding, mode]);

  return null;
}

export default TenantHead;
